module.exports = __webpack_public_path__ + "img/0m.b4276cc3.jpg";